<template>
  <div>
    <div class="flex-grid">
      <Confirm
        :text="deleteText"
        :is-visible="isDelete"
        @onConfirm="onConfirm"
      />
      <Confirm
        :text="duplicateText"
        :is-visible="isDuplicate"
        @onConfirm="onConfirmDuplicate"
      />
      <Loading :is-progress="isProgress" />
      <div class="col1">
        <div class="main_heading">
          <h3>Manage Mailers</h3>
          <a
            class="button_create"
            href="/CreateMailer/"
          >Create New Mailer</a>
          <a
            class="button_create"
            @click="loadMore()"
          >Load More Mailers</a>
        </div>
        <div
          v-if="isPreview"
          class="preview-html"
        >
          <span
            class="close-button"
            @click="closePreview()"
          >X</span>
          <div
            class="html-content"
            v-html="htmlContent"
          />
        </div>
        <v-client-table
          :columns="columns"
          :data="mailersList"
          :options="options"
        >
          <template
            slot="actions"
            slot-scope="props"
          >
            <a
              class="glyphicon glyphicon-eye-open"
              @click="downloadPreviewMailer(props.row.index,true)"
            />
            <a
              :href="`/CreateMailer/?id=${props.row.id}`"
              class="glyphicon glyphicon-edit"
            />
            <a
              class="glyphicon glyphicon-download-alt"
              @click="downloadPreviewMailer(props.row.index)"
            />
            <a
              class="glyphicon glyphicon-duplicate"
              @click="duplicateConfirm(props.row.index)"
            />
            <a
              class="glyphicon glyphicon-trash"
              @click="deleteConfirm(props.row.id,props.row.key)"
            />
          </template>
        </v-client-table>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from '@/components/loading.vue';
import Confirm from '@/components/Confirm.vue';

export default {
  name: 'PrepareMailer',
  components: {
    Loading,
    Confirm,
  },
  data() {
    return {
      columns: [
        'sno',
        'fascia',
        'category',
        'name',
        'created_on',
        'created_by',
        'actions',
      ],
      options: {
        headings: {
          sno: '#',
          fascia: 'Fascia Name',
          category: 'Category Name',
          name: 'Mailer Name',
          actions: 'Actions',
          created_on: 'Created On',
          created_by: 'Created By',
        },
        sortable: ['fascia', 'category', 'name'],
        filterable: ['fascia', 'category', 'name'],
      },
      allMailerList: [],
      isDelete: false,
      isDuplicate: false,
      deleteText: 'Are You Sure Want To Delete?',
      duplicateText: 'Are You Sure Want To Duplicate?',
      mailersList: [],
      currentMailer: '',
      currentKey: '',
      isPreview: false,
      isProgress: true,
      htmlContent: '',
      fasciasList: [],
      categoryList: [],
      usersList: [],
      userdataID: '',
      roleID: '',
      noOfRecords: 200,
      mailersUrl: '',
    };
  },
  created() {
    this.$eventHub.$on('userData', this.getCurrentUser);
  },
  beforeDestroy() {
    this.$eventHub.$off('userData');
  },
  mounted() {
    const getMasterData = () => new Promise((resolve) => {
      fetch('/api/users/all', { credentials: 'same-origin' })
        .then(response => response.json())
        .then((responseJSON) => {
          this.usersList = responseJSON;
        });

      fetch('/api/fascias/all', { credentials: 'same-origin' })
        .then(response => response.json())
        .then((responseJSON) => {
          this.fasciasList = responseJSON;
        });

      fetch('/api/categorylist/all', { credentials: 'same-origin' })
        .then(response => response.json())
        .then((responseJSON) => {
          this.categoryList = responseJSON;
        });
      setTimeout(() => resolve(), 1000);
    });

    getMasterData().then(() => {
      this.getCurrentUser();
      if (this.roleID === '') {
        const getroleId = fetch('/api/getUserData', {
          credentials: 'same-origin',
        });
        getroleId
          .then((response) => {
            if (!response.ok) {
              this.$router.push({ name: 'login' });
            } else {
              return response.json();
            }
            return false;
          })
          .then((res) => {
            if (res.data) {
              this.roleID = res.data.role_id;
              if (this.roleID === 2 || this.roleID === 3) {
                this.mailersUrl = '/api/mailers/all';
                this.getMailerData();
              } else if (this.userdataID) {
                fetch(`/api/users/${this.userdataID}`, {
                  credentials: 'same-origin',
                })
                  .then(response => response.json())
                  .then((data) => {
                    const fasciaIds = [];
                    data.fascias.forEach((fascia) => {
                      fasciaIds.push(fascia._id);
                    });
                    // checking for fasias assigned to get the list of mailers created
                    if (fasciaIds.length === 0) {
                      this.isProgress = false;
                    } else {
                      this.mailersUrl = `/api/employemailers/${fasciaIds}`;
                      this.getMailerData();
                    }
                  });
              }
            }
          });
      } else if (this.roleID === 2 || this.roleID === 3) {
        this.mailersUrl = '/api/mailers/all';
        this.getMailerData();
      } else if (this.userdataID) {
        fetch(`/api/users/${this.userdataID}`, { credentials: 'same-origin' })
          .then(response => response.json())
          .then((data) => {
            const fasciaIds = [];
            data.fascias.forEach((fascia) => {
              fasciaIds.push(fascia._id);
            });
            // checking for fasias assigned to get the list of mailers created
            if (fasciaIds.length === 0) {
              this.isProgress = false;
            } else {
              this.mailersUrl = `/api/employemailers/${fasciaIds}`;
              this.getMailerData();
            }
          });
      }
    });
  },
  methods: {
    getCurrentUser(userData) {
      // you don't have to pass it again from the listener.
      if (userData) {
        this.roleID = userData.role_id;
        this.userdataID = userData.id;
      }
    },
    getMailerData() {
      const getMailers = fetch(`${this.mailersUrl}/${this.noOfRecords}`, {
        credentials: 'same-origin',
      });
      getMailers
        .then(data => data.json())
        .then((data) => {
          let mailersArray = [];
          mailersArray = data.map((mailer, i) => {
            const obj = {
              sno: i + 1,
              id: `${mailer._id}`,
              fascia: `${this.getFasciaName(mailer.fascia_id)}`,
              category: `${this.getTemplateName(mailer.template_category)}`,
              name: `${mailer.mailer_name}`,
              index: i,
              created_on: new Date(mailer.createdOn).toLocaleString(),
              created_by: `${this.getUserName(mailer.createdBy)}`,
              template_id: `${mailer.template_id}`,
              mailer_json_data: `${mailer.mailer_json_data}`,
            };
            return obj;
          });
          this.mailersList = mailersArray;
          this.isProgress = false;
        });
    },
    getFasciaName(fasciaid) {
      const filteredFascia = this.fasciasList.filter(
        fascia => fascia._id === fasciaid,
      );
      return filteredFascia[0].fasica_name;
    },
    getTemplateName(categoryid) {
      const filteredCategory = this.categoryList.filter(
        category => category._id === categoryid,
      );
      return filteredCategory[0].categoryName;
    },
    getUserName(userid) {
      const filteredUser = this.usersList.filter(user => user._id === userid);
      return filteredUser.length > 0 ? filteredUser[0].fullName : "Multi Channel Front-End Team";
    },
    closePreview() {
      this.isPreview = false;
      this.htmlContent = '';
    },
    deleteConfirm(id, key) {
      this.currentMailer = id;
      this.isDelete = true;
      this.currentKey = key;
    },
    onConfirm(state) {
      this.isDelete = false;
      if (state === 'yes') {
        this.deleteprepareMail(this.currentMailer);
      }
    },
    duplicateConfirm(id) {
      this.currentMailer = id;
      this.isDuplicate = true;
    },
    onConfirmDuplicate(state) {
      this.isDuplicate = false;
      if (state === 'yes') {
        this.duplicate(this.currentMailer);
      }
    },
    deleteprepareMail(id) {
      const url = `/api/mailers/${id}`;
      fetch(url, {
        method: 'DELETE',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => res.json())
        .catch(error => this.$toasted.error(
          `Something Went Wrong. Please try again - ${error}`,
          { duration: 3000 },
        ))
        .then(response => this.$toasted.success(response.message, { duration: 3000 }))
        .then(
          this.mailersList.splice(
            this.mailersList.findIndex(user => user.id === id),
            1,
          ),
        );
    },
    downloadPreviewMailer(index, previewOnly) {
      const templateID = this.mailersList[index].template_id;
      const jsonContent = JSON.parse(this.mailersList[index].mailer_json_data);
      let rows = '';
      jsonContent.forEach((mailerData) => {
        let td = '';
        const tdWidth = 100 / mailerData.blocks.length;
        mailerData.blocks.forEach((block) => {
          td += `<td align="center" width="${tdWidth}%">
                        <a href="${block.url}" style="font-size:0; display:block;">
                            <img border="0" src="${block.imageurls}" style="display:block" width="100%" />
                        </a>
                    </td>`;
        });
        rows += `<tr><td><table border="0" cellpadding="0" cellspacing="0" width="100%"><tbody><tr>${td}</tr></tbody></table></td></tr>`;
      });
      const getTemplate = fetch(`/api/fasciaTemplates/${templateID}`, {
        credentials: 'same-origin',
      });
      getTemplate
        .then(data => data.json())
        .then((data) => {
          const headerContent = data.header_html;
          const footerContent = data.footer_html;
          const uspContent = data.usp_html;
          const topSpotContent = data.top_spots_html;
          const bottomSpotContent = data.bottom_spots_html;
          let mainHTML = '';
          mainHTML = headerContent
            + uspContent
            + topSpotContent
            + rows
            + bottomSpotContent
            + footerContent;

          if (previewOnly) {
            this.isPreview = true;
            this.htmlContent = mainHTML;
            return true;
          }
          const a = window.document.createElement('a');
          a.href = window.URL.createObjectURL(
            new Blob([mainHTML], { type: 'text/html' }),
          );
          a.download = this.mailersList[index].name;
          // Append anchor to body.
          document.body.appendChild(a);
          a.click();
          // Remove anchor from body
          document.body.removeChild(a);
          return true;
        });
    },
    loadMore() {
      this.noOfRecords = this.noOfRecords + 200;
      this.getMailerData();
      this.isProgress = false;
    },
    duplicate(index) {
      const { id } = this.mailersList[index];
      const url = `/api/mailers/${id}`;
      fetch(url, {
        method: 'COPY',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => res.json())
        .catch(error => this.$toasted.error(
          `Something Went Wrong. Please try again - ${error}`,
          { duration: 3000 },
        ))
        .then(response => this.$toasted.success(response.message, { duration: 3000 }))
        .then(window.location.reload());
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flex-grid {
  display: flex;
  justify-content: space-between;
}

.col1 {
  width: 100%;
}

.preview-html {
  width: 100%;
  min-height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
  position: absolute;
  z-index: 9;
}

.close-button {
  right: 15px;
  position: fixed;
  color: white;
  cursor: pointer;
  margin-top: 5%;
  background-color: red;
  padding: 10px 15px;
  border-radius: 25px;
  font-weight: 900;
}

.html-content {
  margin: 5% 0;
}
</style>
